<script setup>
import BaseModal from "@/Components/UI/modals/BaseModal.vue";
import { onMounted } from "vue";
import { ref } from "vue";

const { class: className, teleportTo, image } = defineProps({
    show: {
        type: Boolean,
        default: false,
    },
    maxWidth: {
        type: String,
        default: "md",
    },
    // null falls through to BaseModal's own resolution (modalTeleportTarget()).
    teleportTo: {
        type: String,
        default: null,
    },
    // Optional illustration shown centered above the title. Left empty for
    // form-style simple modals; set it for yes/no question dialogs that read
    // nicer with a picture.
    image: {
        type: String,
        default: "",
    },
});

const isMounted = ref(false);
onMounted(() => {
    isMounted.value = true;
});
</script>

<template>
    <BaseModal
        v-if="isMounted"
        :show="show"
        :max-width="maxWidth"
        :class="className"
        :teleport-to="teleportTo"
        centered-y
        @close="$emit('close')"
    >
        <!-- Forward the title into BaseModal's header row (title left, × right). Guarded
             on $slots.title so a caller that provides no title falls back to BaseModal's
             legacy title-less corner-× layout instead of triggering an empty header row. -->
        <template v-if="$slots.title" #title>
            <slot name="title" />
        </template>
        <template #header>
            <slot name="header" />
        </template>
        <img
            v-if="image"
            :src="image"
            alt=""
            class="mx-auto mb-5 max-h-40">
        <p class="text-dark-light mt-5">
            <slot name="description" />
        </p>
        <div>
            <slot name="content" />
        </div>
    </BaseModal>
</template>
